import { render, staticRenderFns } from "./PartnerLogoutView.vue?vue&type=template&id=2fc72952&scoped=true&"
import script from "./PartnerLogoutView.vue?vue&type=script&lang=js&"
export * from "./PartnerLogoutView.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLogoutView.vue?vue&type=style&index=0&id=2fc72952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc72952",
  null
  
)

export default component.exports